var $8189bed27add1ad3$exports = {};
$8189bed27add1ad3$exports = {
  "close": "Zamknij",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " powiadomienie");
      },
      few: function few() {
        return "".concat(formatter.number(args.count), " powiadomienia");
      },
      many: function many() {
        return "".concat(formatter.number(args.count), " powiadomie\u0144");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " powiadomienia");
      }
    }), ".");
  }
};
export { $8189bed27add1ad3$exports as default };